import React, { useState } from 'react';
import AdminLayout from '../../components/AdminLayout/AdminLayout';
import './SubAdminPage.css';

const SubAdminPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);

  const subAdmins = [
    { id: 1, name: 'John Smith', email: 'john.smith@example.com', role: 'Super Admin', permissions: 'Full Access', status: 'Active', lastLogin: '12.12.2025' },
    { id: 2, name: 'Sarah Johnson', email: 'sarah.j@example.com', role: 'Content Manager', permissions: 'News, Products', status: 'Active', lastLogin: '11.12.2025' },
    { id: 3, name: 'Mike Wilson', email: 'mike.w@example.com', role: 'Support Agent', permissions: 'Support, Messages', status: 'Active', lastLogin: '10.12.2025' },
    { id: 4, name: 'Emily Brown', email: 'emily.b@example.com', role: 'Finance Manager', permissions: 'Payments, Reports', status: 'Inactive', lastLogin: '05.12.2025' },
    { id: 5, name: 'David Lee', email: 'david.l@example.com', role: 'Product Manager', permissions: 'Products, Categories', status: 'Active', lastLogin: '12.12.2025' },
  ];

  const roles = [
    { id: 1, name: 'Super Admin', description: 'Full system access', users: 2 },
    { id: 2, name: 'Content Manager', description: 'Manage news and content', users: 3 },
    { id: 3, name: 'Support Agent', description: 'Handle support tickets', users: 5 },
    { id: 4, name: 'Finance Manager', description: 'Manage payments and reports', users: 2 },
    { id: 5, name: 'Product Manager', description: 'Manage products and categories', users: 4 },
  ];

  return (
    <AdminLayout>
      <div className="sub-admin-content">
        <div className="sa-page-header">
          <div className="sa-page-title-section">
            <h1 className="sa-page-title">Roles & Permissions</h1>
            <p className="sa-page-description">Manage admin users and their access levels.</p>
          </div>
          <button className="sa-add-btn" onClick={() => setShowAddModal(true)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Add Sub Admin</span>
          </button>
        </div>

        <div className="sa-grid">
          {/* Roles Section */}
          <div className="sa-roles-section">
            <h2 className="sa-section-title">Available Roles</h2>
            <div className="sa-roles-list">
              {roles.map((role) => (
                <div key={role.id} className="sa-role-card">
                  <div className="sa-role-info">
                    <h3 className="sa-role-name">{role.name}</h3>
                    <p className="sa-role-desc">{role.description}</p>
                    <span className="sa-role-users">{role.users} users</span>
                  </div>
                  <button className="sa-role-edit">Edit</button>
                </div>
              ))}
              <button className="sa-add-role-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 5V19M5 12H19" stroke="#1F396C" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <span>Add New Role</span>
              </button>
            </div>
          </div>

          {/* Sub Admins Table */}
          <div className="sa-admins-section">
            <div className="sa-list-header">
              <h2 className="sa-section-title">Sub Admins</h2>
              <div className="sa-search-box">
                <input 
                  type="text" 
                  placeholder="Search by name or email..." 
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <circle cx="9.16667" cy="9.16667" r="5.83333" stroke="#969696" strokeWidth="1.5"/>
                  <path d="M14.166 14.1665L17.4993 17.4998" stroke="#969696" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
            </div>

            <div className="sa-table">
              <div className="sa-table-header">
                <div className="sa-th">Name</div>
                <div className="sa-th">Email</div>
                <div className="sa-th">Role</div>
                <div className="sa-th">Permissions</div>
                <div className="sa-th">Status</div>
                <div className="sa-th">Last Login</div>
                <div className="sa-th">Action</div>
              </div>
              <div className="sa-table-body">
                {subAdmins.map((admin) => (
                  <div key={admin.id} className="sa-table-row">
                    <div className="sa-td sa-td-name">
                      <div className="sa-user-avatar"></div>
                      {admin.name}
                    </div>
                    <div className="sa-td">{admin.email}</div>
                    <div className="sa-td">
                      <span className="sa-role-badge">{admin.role}</span>
                    </div>
                    <div className="sa-td sa-td-permissions">{admin.permissions}</div>
                    <div className="sa-td">
                      <span className={`sa-status-badge ${admin.status.toLowerCase()}`}>{admin.status}</span>
                    </div>
                    <div className="sa-td">{admin.lastLogin}</div>
                    <div className="sa-td sa-td-action">
                      <button className="sa-edit-btn">Edit</button>
                      <button className="sa-delete-btn">Delete</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default SubAdminPage;
